import React from 'react'
import gql from 'graphql-tag'
import _ from 'lodash'
import {
  Query
} from 'react-apollo'

import apolloClient from '../../../services/ApolloClient'
import ResearchSelectedTerritoriesList from './ResearchSelectedTerritoriesList'
import { getTerritoryQuery } from '../../../logic/TerritoryQueryUtils'

const STATE_AGGREGATED = gql`
 query ResearchSelectedTerritoriesListContainer {
  research @client {
    lastTerritoriesAggregated
  }
}`

const STATE = gql`
  query ResearchSelectedTerritoriesListContainer {
    research @client {
      lastTerritoriesAggregated
      selectedTerritories {
        id
        name,
        cd_muns
      }
      selectedTerritoryOnModalSelect {
        id
        name,
        cd_muns
      }
      selectedTerritoryTypeOnModalSelect
      selectedTerritoryType
      territoryFilters {
        biomes {
          id
          name
          cd_muns
          kind
        }
        regions {
          id
          name
          cd_muns
          kind
        }
        states {
          id
          name
          cd_muns
          kind
        }
        mesoregions {
          id
          name
          cd_muns
          kind
        }
        microregions {
          id
          name
          cd_muns
          kind
        }
        cities {
          id
          name
          cd_muns
          kind
        }
      }
    }
  }
`

export default class ResearchSelectedTerritoriesListContainer extends React.PureComponent {
  territoryQuery(territoryType, searchTerritoryType) {
    return getTerritoryQuery(territoryType, searchTerritoryType);
  }

  gatherFilterIds(territoryFilters) {
    return _.map(
      _.concat(
        territoryFilters.biomes,
        territoryFilters.regions,
        territoryFilters.states,
        territoryFilters.mesoregions,
        territoryFilters.microregions,
        territoryFilters.cities
      ),
      'id'
    )
  }

  resetModalState() {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedFilter: null,
          selectedTerritoryTypeOnModalSelect: null,
          selectedTerritoryOnModalSelect: null,
          territoryFilters: {
            __typename: 'ResearchTerritoryFiltersState',
            biomes: [],
            regions: [],
            states: [],
            mesoregions: [],
            microregions: [],
            cities: []
          }
        }
      }
    })
  }

  onChangeTerritoryType(territoryType) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedFilter: null,
          selectedTerritories: [],
          selectedTerritoryType: territoryType
        }
      }
    })
  }

  updateSelectedTerritories(newTerritories) {
    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedTerritories: newTerritories
        }
      }
    })
  }

  addTerritories(territories, territoriesToAppend) {
    let newTerritories = [...territories, ...territoriesToAppend]
    this.updateSelectedTerritories(_.uniqBy(newTerritories, 'id'))
  }

  addTerritory(territories, territory) {
    let newTerritories = [...territories, territory]
    this.updateSelectedTerritories(_.uniqBy(newTerritories, 'id'))
  }

  removeTerritory(territories, territory) {
    let newTerritories = _.reject(territories, { id: territory.id })
    this.updateSelectedTerritories(newTerritories)
  }

  cleanTerritories = () => {
    this.updateSelectedTerritories([])
  }

  generateBadge = (territory, _index, territories) => {
    return {
      content: territory.name,
      onCloseClick: () => {
        this.removeTerritory(territories, territory)
      }
    }
  }

  generateBadges(territories) {
    return _.map(territories, this.generateBadge)
  }

  async _onAddAllTerritoryModalClick(data) {
    this.addTerritory(
      data.research.selectedTerritories, 
      {...data.research.selectedTerritoryOnModalSelect, isAggregated: true}
    )
  }

  async _onAddAllTerritoriesModalClick(data) {
/*     let query = this.territoryQuery(
      data.research.selectedTerritoryType,
      data.research.selectedTerritoryTypeOnModalSelect
    )

    let filterIds = this.gatherFilterIds(data.research.territoryFilters)
    let result = await apolloClient.query({
      query,
      variables: {
        biomeIds: filterIds,
        name: '',
        recgeoIds: filterIds
      }
    }) */

    let selected = _.concat(
      data.research.territoryFilters.biomes,
      data.research.territoryFilters.regions,
      data.research.territoryFilters.states,
      data.research.territoryFilters.mesoregions,
      data.research.territoryFilters.microregions,
      data.research.territoryFilters.cities
    );

    let results = selected.map(x => {       
      x.isAggregated = false;
      return x;
    });
    this.addTerritories(data.research.selectedTerritories, results)
  }

  renderComponent = ({ data }) => {
    return (
    <ResearchSelectedTerritoriesList
      badges={ this.generateBadges(data.research.selectedTerritories) }
      isModalAddButtonDisabled={ !data.research.selectedTerritoryOnModalSelect }
      isModalAddAllButtonDisabled={
        _.concat(
          data.research.territoryFilters.biomes,
          data.research.territoryFilters.regions,
          data.research.territoryFilters.states,
          data.research.territoryFilters.mesoregions,
          data.research.territoryFilters.microregions,
          data.research.territoryFilters.cities
        ).length < 1 || !data.research.selectedTerritoryTypeOnModalSelect
      }
      onAddAllTerritoriesModalClick={ async () => { this._onAddAllTerritoriesModalClick(data) } }
      onAddTerritoriesModalClick={ async () => { this._onAddAllTerritoryModalClick(data) } }
      onChangeTerritoryType={ this.onChangeTerritoryType }
      onCleanTerritoriesClick={ this.cleanTerritories }
      onModalClose={ this.resetModalState }
      selectedTerritoryType={ data.research.selectedTerritoryType }
    />
    )
  }

  render() {
    return (
      <Query query={ STATE }>
        { this.renderComponent }
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchSelectedTerritoriesList/ResearchSelectedTerritoriesList.container.js